/**
 * Topbar — barra superior fija (56px) compartida por todas las rutas
 * autenticadas.
 *
 * Layout (de izq a der):
 *  - Slot opcional `breadcrumb` (rutas internas pueden inyectar via
 *    children futuro; en B.5.c.1 vacío)
 *  - SearchBar (stub)
 *  - Spacer
 *  - NotificationsBell · LanguageSwitcher · ThemeToggle · UserMenu
 *
 * El usuario activo (`me`) se inyecta como prop para que el UserMenu y
 * cualquier otro consumer reusen el mismo cache de TanStack Query del
 * RootLayout.
 */

import type { MeResponse } from '../../api/me'
import { LanguageSwitcher } from '../LanguageSwitcher'
import { ThemeToggle } from '../ThemeToggle'
import { NotificationsBell } from './NotificationsBell'
import { SearchBar } from './SearchBar'
import { UserMenu } from './UserMenu'

interface TopbarProps {
  me: MeResponse | undefined
}

export function Topbar({ me }: TopbarProps) {
  return (
    <header className="h-14 border-b border-line bg-surface flex items-center px-6 gap-4">
      <SearchBar />

      <div className="flex-1" />

      <div className="flex items-center gap-1">
        <NotificationsBell />
        <LanguageSwitcher />
        <ThemeToggle />
        <div className="h-6 w-px bg-line mx-1" aria-hidden="true" />
        <UserMenu me={me} />
      </div>
    </header>
  )
}
